import PlatformBreakoutTableCard from './PlatformBreakoutTableCard';

export default PlatformBreakoutTableCard;
